import { onlyNumericRegex, passwordRegex } from 'constants/regex';
import { t } from 'i18next';
import { IVerifyEmailResponse } from 'services/users/types';
import { UsersApi } from 'services/users/users.api';
import * as Yup from 'yup';

const getRequired = (): Yup.StringSchema => Yup.string().required(t('required'));

const getRequiredEmail = (): Yup.StringSchema => getRequired().email(t('invalidFormat'));

export const getRequiredPassword = (): Yup.StringSchema =>
  getRequired().matches(
    passwordRegex,
    t('passwordError')
  );

const confirmationCodeValidation = {
  code: getRequired()
    .min(6, t('codeLengthError'))
    .matches(onlyNumericRegex, t('codeLengthError')),
};

const emailFieldValidation = (
  validationName: string,
  validationMessage: string,
  validationCondition: (verifyEmailResponse: IVerifyEmailResponse) => boolean,
) =>
  getRequiredEmail().test(
    validationName,
    t(validationMessage),
    async (email: string = ''): Promise<boolean> => {
      const registeredData = await UsersApi.verifyEmail({ email });
      return validationCondition(registeredData);
    },
  );

export const signUpPersonalInfoSchema = Yup.object({
  email: emailFieldValidation(
    'email-already-exists-validation',
    t('emailAlreadyExistsError'),
    (registeredData) => !Object.values(registeredData.registeredAccounts).includes(true),
  ),
  password: getRequiredPassword(),
});

export const confirmationCodeSchema = Yup.object({
  ...confirmationCodeValidation,
});

export const signInSchema = Yup.object({
  email: getRequiredEmail(),
  password: getRequiredPassword(),
});

export const resetPasswordEmailSchema = Yup.object({
  email: emailFieldValidation('email-not-exists-validation', t('emailNotExistsError'), (registeredData) =>
    Object.values(registeredData.registeredAccounts).includes(true),
  ),
});

export const resetPasswordSchema = Yup.object({
  password: getRequiredPassword(),
  confirmPassword: getRequiredPassword().oneOf([Yup.ref('password')], t('passwordsDoNotMatch')),
});
